import { render } from "./organization_invite_setup.html?vue&type=template&id=170567c1&external"
import script from "./organization_invite_setup.js?vue&type=script&lang=js&external"
export * from "./organization_invite_setup.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__